import type { MouseEventHandler } from 'react';

import { ProductCarousel } from 'components/common/ProductCarousel/ProductCarousel';
import useMartyContext from 'hooks/useMartyContext';

interface SponsoredBrandsCarouselProps {
  heading: string | null;
  slides: React.ReactNode[];
  overrides?: {
    root?: string;
    item?: string;
    backButton?: string;
    forwardButton?: string;
  };
  forwardButtonOnClick?: MouseEventHandler<HTMLButtonElement>;
}

const SponsoredBrandsCarousel = (props: SponsoredBrandsCarouselProps) => {
  const { heading, slides, overrides, forwardButtonOnClick } = props;
  const { testId } = useMartyContext();
  const hasHeading = Boolean(heading?.trim());

  return (
    <section className="flex flex-col gap-4 md-plus:zappos:mr-4" data-test-id={testId('sponsoredBrandsCarousel')}>
      {hasHeading && <h2 className={'text-xl/none font-semibold zappos:heading-m'}>{heading}</h2>}
      <ProductCarousel overrides={overrides} options={{ slidesToScroll: 1 }} slides={slides} forwardButtonOnClick={forwardButtonOnClick} />
    </section>
  );
};

export default SponsoredBrandsCarousel;
